const NAMESPACE = 'BOOKING_DATA';

const SET_SEAT_INFO = `${NAMESPACE}/SET_SEAT_INFO`;
const SET_BOOKING_SESSION_ID = `${NAMESPACE}/SET_BOOKING_SESSION_ID`;
const SET_BOOKING_FORM = `${NAMESPACE}/SET_BOOKING_FORM`;
const SET_BOOKING_INFO = `${NAMESPACE}/SET_BOOKING_INFO`;
const SET_QUOTE_SUMMARY = `${NAMESPACE}/SET_QUOTE_SUMMARY`;
const RESET_BOOKING_INFO = `${NAMESPACE}/RESET_BOOKING_INFO`;
const SET_DETAILS = `${NAMESPACE}/SET_DETAILS`;
const SET_PAYMENT = `${NAMESPACE}/SET_PAYMENT`;
const SET_PAYMENT_METHODS = `${NAMESPACE}/SET_PAYMENT_METHODS`;
const SET_VALIDATIONS = `${NAMESPACE}/SET_VALIDATIONS`;
const SET_LOCALITIES = `${NAMESPACE}/SET_LOCALITIES`;
const SET_FIELD_VALIDITY = `${NAMESPACE}/SET_FIELD_VALIDITY`;
const SET_FIELD_VALUE = `${NAMESPACE}/SET_FIELD_VALUE`;
const RESET_FIELD_VALUE = `${NAMESPACE}/RESET_FIELD_VALUE`;
const SET_ORDER_ID = `${NAMESPACE}/SET_ORDER_ID`;
const SET_BOOKING_STATUS = `${NAMESPACE}/SET_BOOKING_STATUS`;
const RESET_BOOKING_STATUS = `${NAMESPACE}/RESET_BOOKING_STATUS`;
const SET_INSURANCE_ORDER_ID = `${NAMESPACE}/SET_INSURANCE_ORDER_ID`;
const SET_INSURANCE_STATUS = `${NAMESPACE}/SET_INSURANCE_STATUS`;
const RESET_INSURANCE_STATUS = `${NAMESPACE}/RESET_INSURANCE_STATUS`;
const SET_TRIP_CONFIRMATION = `${NAMESPACE}/SET_TRIP_CONFIRMATION`;
const RESET_TRIP_CONFIRMATIONS = `${NAMESPACE}/RESET_TRIP_CONFIRMATIONS`;
const SET_FIELD_OPTIONS_BY_TYPE = `${NAMESPACE}/SET_FIELD_OPTIONS_BY_TYPE`;
const SET_FIELD_OPTIONS_BY_PATH = `${NAMESPACE}/SET_FIELD_OPTIONS_BY_PATH`;
const SET_INSURANCE_SELECTED = `${NAMESPACE}/SET_INSURANCE_SELECTED`;
const RESET_INSURANCE_SELECTED = `${NAMESPACE}/RESET_INSURANCE_SELECTED`;
const SET_TRIP_INFO_TO_DISPLAY = `${NAMESPACE}/SET_TRIP_INFO_TO_DISPLAY`;
const RESET_TRIP_INFO = `${NAMESPACE}/RESET_TRIP_INFO`;
const SET_ACCOUNT_EXISTS = `${NAMESPACE}/SET_ACCOUNT_EXISTS`;
const SET_FIELD_VALIDATION = `${NAMESPACE}/SET_FIELD_VALIDATION`;
const SET_TRIP_NOT_AVAILABLE = `${NAMESPACE}/SET_TRIP_NOT_AVAILABLE`;
const RESET_TRIP_NOT_AVAILABLE = `${NAMESPACE}/RESET_TRIP_NOT_AVAILABLE`;
const SET_GOOGLE_DEPART_ID = `${NAMESPACE}/SET_GOOGLE_DEPART_ID`;
const SET_GOOGLE_DESTINATION_ID = `${NAMESPACE}/SET_GOOGLE_DESTINATION_ID`;
const RESET_GOOGLE_PLACE_IDS = `${NAMESPACE}/RESET_GOOGLE_PLACE_IDS`;
const SET_ALL_FIELDS_AS_MODIFIED = `${NAMESPACE}/SET_ALL_FIELDS_AS_MODIFIED`;
const SET_FIELDS_AS_MODIFIED = `${NAMESPACE}/SET_FIELDS_AS_MODIFIED`;

export {
    RESET_BOOKING_INFO,
    RESET_BOOKING_STATUS,
    RESET_FIELD_VALUE,
    RESET_GOOGLE_PLACE_IDS,
    RESET_INSURANCE_SELECTED,
    RESET_INSURANCE_STATUS,
    RESET_TRIP_CONFIRMATIONS,
    RESET_TRIP_INFO,
    RESET_TRIP_NOT_AVAILABLE,
    SET_ACCOUNT_EXISTS,
    SET_ALL_FIELDS_AS_MODIFIED,
    SET_BOOKING_FORM,
    SET_BOOKING_INFO,
    SET_BOOKING_SESSION_ID,
    SET_BOOKING_STATUS,
    SET_DETAILS,
    SET_FIELDS_AS_MODIFIED,
    SET_FIELD_OPTIONS_BY_PATH,
    SET_FIELD_OPTIONS_BY_TYPE,
    SET_FIELD_VALIDATION,
    SET_FIELD_VALIDITY,
    SET_FIELD_VALUE,
    SET_GOOGLE_DEPART_ID,
    SET_GOOGLE_DESTINATION_ID,
    SET_INSURANCE_ORDER_ID,
    SET_INSURANCE_SELECTED,
    SET_INSURANCE_STATUS,
    SET_LOCALITIES,
    SET_ORDER_ID,
    SET_PAYMENT,
    SET_PAYMENT_METHODS,
    SET_QUOTE_SUMMARY,
    SET_SEAT_INFO,
    SET_TRIP_CONFIRMATION,
    SET_TRIP_INFO_TO_DISPLAY,
    SET_TRIP_NOT_AVAILABLE,
    SET_VALIDATIONS,
};

export default NAMESPACE;
